exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".batch-filter[data-v-7b7f4a1c] {\n  display: table-cell;\n}\n", ""]);

// exports
